import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Link as MLink,
  Menu,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import appLogo from "../../assets/images/landing-page/app-logo.png";
import langIcon from "../../assets/images/landing-page/language.png";
import MenuIcon from "@mui/icons-material/Menu";
import useWindowSize from "../../hooks/useWindowSize";
import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import i18n from "../../localization/LocalesConfig";

const Header = ({ currentLang, appLinks }) => {
  const { updateCurrentLang } = useAuth();

  const { width } = useWindowSize();
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const langLabel = currentLang === "ar" ? "العربية" : "English";
  const [activeLanguage, setActiveLanguage] = useState(langLabel);
  // const [direction, setDirection] = useState(localStorage.getItem("direction"));

  useEffect(() => {
    // Add any necessary logic for the header here
  }, [theme]);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigationItems = appLinks;

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  const languages = [
    {
      label: "English",
      lang: "en",
    },
    {
      label: "العربية",
      lang: "ar",
    },
  ];

  const fullName = localStorage.getItem("fullName");
  const isLoggedIn = localStorage.getItem("token");

  const handleLogout = () => {
    handleMenuClose();
    localStorage.setItem("token", "");
    navigate("/signin");
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [langEl, setLangEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // Set anchor to the icon button
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Close the menu by setting anchor to null
  };

  const handleLangMenuOpen = (event) => {
    setLangEl(event.currentTarget); // Set anchor to the icon button
  };

  const handleLangMenuClose = (lang) => {
    setLangEl(null); // Close the menu by setting anchor to null
    if (lang === "en" || lang === "ar") {
      localStorage.setItem("preferredLanguage", lang);
      localStorage.setItem("direction", lang === "en" ? "ltr" : "rtl");

      updateCurrentLang(lang);

      i18n.changeLanguage(lang);
      console.log("handler called", lang);
      // setDirection(lang === "en" ? "ltr" : "rtl");
      setActiveLanguage(lang === "en" ? "English" : "العربية");
    }
  };

  return (
    <AppBar
      sx={{
        backgroundColor: "white",
        boxShadow: 0,
        padding: "1%",
        width: "100%", // Make sure the AppBar takes up the full width
        overflowX: "hidden", // Prevent horizontal scroll
        position: "sticky",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%", // Ensure Toolbar takes full width
          overflowX: "hidden", // Prevent horizontal scroll in Toolbar
        }}
      >
        {/* Left: Logo */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#000" }}>
            <Link to="/">
              <img src={appLogo} alt="logo" width={100} height={51.68} />
            </Link>
          </Typography>
        </Box>

        {/* Center: Navigation Items */}
        {width > 1032 && (
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center", // Adjust for RTL
            }}
          >
            {navigationItems?.map((item, index) => (
              <Button
                href={item.link}
                key={index}
                sx={{
                  color: theme.palette.navItem.main,
                  fontWeight: "700",
                  fontSize: "16px",
                  fontFamily: "Tajawal-Regular",
                }}
              >
                {t(item.label)}
              </Button>
            ))}
          </Box>
        )}

        {/* Right: Profile, Language, and Hamburger Icon */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: width > 600 ? "15px" : "1px",
          }}
        >
          {isLoggedIn ? (
            <>
              {width > 500 && (
                <Typography
                  sx={{
                    color: "#004D8A",
                    fontSize: width > 600 ? "16px" : "12px",
                    fontWeight: "700",
                    marginLeft: "30px",
                    fontFamily: "Tajawal-Regular",
                  }}
                >
                  {t("Welcome")} {fullName ? fullName : t("Guest")}
                </Typography>
              )}

              <IconButton onClick={handleMenuOpen}>
                <AccountCircle
                  sx={{ fontSize: width > 600 ? 50 : 36, color: "#004D8A" }}
                />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)} // Open menu if anchorEl is set
                onClose={handleMenuClose} // Close menu on outside click
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Set dropdown position
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                  sx: {
                    width: activeLanguage === "العربية" ? "140px" : "100px",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center", // Set your desired width here
                  },
                }}
              >
                <MenuItem
                  onClick={handleMenuClose}
                  style={{
                    color: "#004D8A",
                    fontFamily: "Tajawal-Bold",
                    cursor: "pointer",
                  }}
                >
                  {t("Setting")}
                </MenuItem>
                <MenuItem
                  onClick={handleLogout}
                  style={{
                    color: "#004D8A",
                    fontFamily: "Tajawal-Bold",
                    cursor: "pointer",
                    marginTop: "-10%",
                  }}
                >
                  {t("Logout")}
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <a
                href="https://customer-panel.microband.online/signin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  sx={{
                    marginLeft: width < 600 ? "20%" : "0px",
                    color: "white",
                    width:
                      langLabel === "en"
                        ? width > 600
                          ? "113px"
                          : "30%"
                        : width > 600
                          ? "153px"
                          : "30%",
                    backgroundColor: theme.palette.button.primary,
                    fontFamily: "Tajawal-Regular",
                  }}
                >
                  {t("Signin")}
                </Button>
              </a>

              <a
                href="https://customer-panel.microband.online/signup"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="outlined"
                  sx={{
                    marginLeft: width < 600 ? "20%" : "0px",
                    border: "1px solid #3173B1",
                    width: width > 600 ? "126px" : "35%",
                    color: "#3173B1",
                    backgroundColor: theme.palette.button.light,
                    fontFamily: "Tajawal-Regular",
                  }}
                >
                  {t("Signup")}
                </Button>
              </a>
            </>
          )}

          {/* Language Icon with Menu */}
          <IconButton sx={{ color: "#000" }} onClick={handleLangMenuOpen}>
            <img
              src={langIcon}
              alt="language"
              width={width > 600 ? 50 : 30}
              height={width > 600 ? 50 : 30}
            />
          </IconButton>
          <Menu
            anchorEl={langEl}
            open={Boolean(langEl)} // Open menu if anchorEl is set
            onClose={() => setLangEl(null)} // Close menu on outside click
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Set dropdown position
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                width: "100px",
                display: "flex",
                justifyContent: "center",
                textAlign: "center", // Set your desired width here
              },
            }}
          >
            {languages.map((item, index) => (
              <MenuItem
                onClick={() => handleLangMenuClose(item.lang)}
                style={{
                  color: "#004D8A",
                  fontFamily: "Tajawal-Bold",
                  cursor: "pointer",
                }}
                key={index}
              >
                {item.label}
              </MenuItem>
            ))}
          </Menu>
          {width > 450 && (
            <Typography sx={{ color: "#004D8A", marginTop: "3%" }}>
              {activeLanguage}
            </Typography>
          )}

          {/* Hamburger Icon for Mobile */}
          {width <= 1032 && (
            <IconButton
              sx={{ color: "#000" }}
              onClick={() => toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Box>
      </Toolbar>

      {/* Drawer for Mobile View */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => toggleDrawer(false)}
      >
        <Box
          sx={{ width: 180 }}
          role="presentation"
          onClick={() => toggleDrawer(false)}
        >
          <List>
            {navigationItems?.map((item, index) => (
              <ListItem button key={index}>
                <MLink
                  href={item.link}
                  style={{
                    color: theme.palette.navItem.main,
                    textDecoration: "none",
                  }}
                >
                  <ListItemText
                    primary={t(item.label)}
                    primaryTypographyProps={{
                      fontSize: "18px",
                      fontFamily: "Tajawal-Regular",
                    }}
                  ></ListItemText>
                </MLink>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Header;
